import { createSlice } from "@reduxjs/toolkit";

const initialState = { planPromoDiscount: "" };

export const promoCodesStateSlice = createSlice({
  name: "promoCodesStateSlice",
  initialState,
  reducers: {
    createPromoCodesState: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetPromoCodesState: () => {
      return initialState;
    },
  },
});

export const { createPromoCodesState, resetPromoCodesState } = promoCodesStateSlice.actions;
export default promoCodesStateSlice.reducer;
